import * as types from "./types";
import router from '../../../../router';
import {
  JSON_STRING,
  HttpClient,
  MHTTPCL
} from "../../../../services/http/http-client";
import { ProductGroupsService } from "../../services/product-groups.service";
import { getNavTabModule } from "../../../../dt-plugins/sidewindow/nav-tab";
import { setMainNavInactive } from "../../../../store/app/mutations";
import { EOL_REACHED } from "../../../../dt-plugins/advanced-search/load.model";
// Action Object for Product_groupsCatalog. Import the types from product_groups/types.js and Invoke Actions from the Vuex Host Components.
const NavTabModule = getNavTabModule(
  types.Product_groupDetails,
  "product_groupDetails"
);

export const product_groupsCatalogActions = {
  async [types.Product_groupsCatalogData.FETCH.ALL](
    { commit, getters, dispatch },
    payload
  ) {
    const product_groupsCatalogData = await HttpClient.mergeRequests([]);
    console.log(product_groupsCatalogData);
    commit(types.Product_groupsCatalogData.SET.ALL, product_groupsCatalogData);
  },
  async [types.Product_groupsList.FETCH.ALL](
    { commit, getters, dispatch },
    payload
  ) {
    console.log('aaaaaaaaaaaaaaaaaa')
    let res;
    const { start, row_count, searchMode, basicFilter } = payload;
    if (searchMode == 'none') {
      if (start == 0) {
        console.log('none')
        res =await ProductGroupsService.fetchProductGroupsList(start,row_count);
        commit(types.Product_groupsList.SET.ALL, res.data);
      } else {
        res = await ProductGroupsService.fetchProductGroupsList(start,row_count);
        commit(types.Product_groupsList.SET.ALL, {
          ...getters.product_groupsList,
          product_groups: [
            ...getters.product_groupsList?.product_groups,
            ...res.data.product_groups,
          ]
        });

        // Setting EOL
        if (!(res?.data?.product_groups?.length > 0)) {
          return EOL_REACHED;
        }
      }

    } 
    else if (searchMode == 'basic') {
      const { searchString } = basicFilter;

      res = await ProductGroupsService.fetchProductGroupsList(start,row_count,searchString);

      if (start == 0) {
        commit(types.Product_groupsList.SET.ALL, {
          ...getters.product_groupsList,
          product_groups: res?.data?.product_groups
        });
      } else {
        commit(types.Product_groupsList.SET.ALL, {
          ...getters.product_groupsList,
          product_groups: [
            ...getters.product_groupsList.product_groups,
            ...res.data.product_groups
          ]
        });
      }


      // Setting EOL
      if (!(res?.data?.product_groups?.length > 0)) {
        return EOL_REACHED;
      }
    }
   
    // console.log("Product_groupsList.FETCH.ALL");
    // const product_groupsListRes = await ProductGroupsService.fetchProductGroupsList();

    // console.log("product_groupsListRes ", product_groupsListRes.data);
    // commit(types.Product_groupsList.SET.ALL, product_groupsListRes.data);
  },
  // async [types.Product_groupsList.SET.ALL]({ commit }, payload) {
  //   console.log("Payload", payload);
  //   commit(types.Product_groupsList.SET.ALL, payload);
  // },

  async [types.Product_groupDetails.FETCH.SINGLE](
    { commit, getters, dispatch },
    payload = {}
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    let { flag, product_group, reload } = payload;

    flag = typeof flag === "boolean" ? flag : true;

    setMainNavInactive(commit, flag);

    const primaryKey = "product_group_id";
    const itemName = "product_group";
    const item = payload[itemName];

    if (!item) {
      return;
    }

    const primaryKeyValue = item[primaryKey];
    const detailsGetterKey = "product_groupDetails";
    const DetailsAction = types.Product_groupDetails;

    // Check Reload and prexisting Item Logic

    if (getters?.[detailsGetterKey]?.[primaryKeyValue] && !reload) {
      return;
    }

    NavTabHelper.setSingleNavTabDetails(primaryKeyValue, () => {
      return {
        [itemName]: item,
        loading: true
      };
    });

    // HTTP Req

    const detailsResponse = await HttpClient.mergeRequests([
      ProductGroupsService.fetchProductGroupDetails(product_group.product_group_id),
      ProductGroupsService.productGroupOverviewData(product_group.product_group_id),
    ]);
    
    
   // await 
    console.log("details Response data", detailsResponse);

    NavTabHelper.setSingleNavTabDetails(
      primaryKeyValue,
      (detailsDict, product) => {
        return {
          ...product,
          ...detailsResponse,
          loading: false
        };
      }
    );
  },
  ...NavTabModule.implementActions(
    "product_group_id",
    "product_groups/product_group_id/tab",
    "product_groups",
    () => router,
    "catalog",
    (value, key) => {
      return {
        title:
          value &&
            value.product_group &&
            value.product_group.product_group_name1
            ? value.product_group.product_group_name1
            : key,
        full_title:
          value &&
            value.product_group &&
            value.product_group.product_group_name1
            ? value.product_group.product_group_name1
            : key
      };
    }
  ),

  // Action of Updating single Object
  async [types.Product_groupDetails.UPDATE.SINGLE](
    { dispatch, getters },
    payload
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { name, value, item } = payload;
    const { product_group } = item;
    const { product_group_id } = product_group;

    // const productGroupObj = getters.Product_groupDetails[product_group_id];
    // console.log({ productOB: productGroupObj });

    NavTabHelper.updateSingleNavTabDetails(
      product_group_id,
      productGroupObj => {
        return {
          product_group: {
            ...productGroupObj.product_group,
            [name]: value
          }
        };
      }
    );

    const table = "l_product_groups";

    const updatedProductDetailsRes = await MHTTPCL.modifyJSON(
      undefined,
      product_group_id,
      name,
      value,
      table
    );
  },
  async [types.ProductGroupProducts.SET.ALL]({ dispatch, getters }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { value, item } = payload;
    const { product_group } = item;
    const { product_group_id } = product_group;

    NavTabHelper.updateSingleNavTabDetails(
      product_group_id,
      productGroupObj => {
        return {
          ...productGroupObj.product_group,
          products: value
        };
      }
    );
  },

  async [types.ProductGroupProducts.DELETE.SINGLE](
    { commit, getters, dispatch },
    payload
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const relation_id = payload.item.relation_id;
    const product_group_id = payload.product_group_id;

    NavTabHelper.updateSingleNavTabDetails(
      product_group_id,
      productGroupObj => {
        return {
          ...productGroupObj,
          products: productGroupObj.products.filter(
            e => e.relation_id != relation_id
          )
        };
      }
    );

    await ProductGroupsService.removeProduct(relation_id);
  },

  // Deleted Product Groups List
  async [types.Product_groupsList.DELETE.SINGLE]({ commit, getters }, item) {
    const { product_group_id } = item;

    let newProduct_groupsList = getters.product_groupsList.product_groups.filter(
      e => e.product_group_id != product_group_id
    );

    commit(types.Product_groupsList.SET.ALL, {
      ...getters.product_groupsList,
      product_groups: newProduct_groupsList
    });

    const deletedProductGruop = await ProductGroupsService.removeProductGroup(
      product_group_id
    );
  }
};
